/**
 * After sign-in, hand the first touch captured on the public pages to the server, once per device.
 * The server keeps it only if this is a brand-new account (see functions/src/acquisition.ts), so a
 * returning sign-in on a new device is never counted as a sign-up.
 */
import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";
import { captureTouch, readTouches } from "../marketing/attribution";

const record = httpsCallable<Record<string, unknown>, { recorded: boolean }>(functions, "recordAcquisition");
const SENT = "timo-acquisition-sent";

export function sendAcquisition() {
  try {
    if (localStorage.getItem(SENT)) return;
    // Someone who arrived straight at /app (an extension, a bookmark) still gets a touch.
    if (!readTouches().first) captureTouch();
    const { first, last } = readTouches();
    void record({ firstTouch: first, lastTouch: last }).then(() => localStorage.setItem(SENT, "1")).catch(() => {});
  } catch { /* storage blocked: best-effort */ }
}

/** The optional "how did you first hear about Timo?" answer. Never replaces the captured touch. */
export function sendSelfReport(answer: string) {
  // Touches ride along, so the answer can't race ahead of the first call and leave an empty record.
  const { first, last } = readTouches();
  void record({ selfReport: answer, firstTouch: first, lastTouch: last }).catch(() => {});
}
